export default "__VITE_ASSET__1RIjWJgV__"